var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentation2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/business/presentation_2_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 3C21.5523 3 22 3.44772 22 4C22 4.55228 21.5523 5 21 5V16C21 17.1046 20.1046 18 19 18H13.9453L16.2382 20.2929C16.6287 20.6834 16.6287 21.3166 16.2382 21.7071C15.8476 22.0976 15.2145 22.0976 14.824 21.7071L11.9955 18.8787L9.1671 21.7071C8.77657 22.0976 8.14341 22.0976 7.75288 21.7071C7.36236 21.3166 7.36236 20.6834 7.75288 20.2929L10.0458 18H5C3.89543 18 3 17.1046 3 16V5C2.44772 5 2 4.55228 2 4C2 3.44772 2.44772 3 3 3H21ZM19 5H5V16H19V5ZM17.6571 7.17165C18.0476 7.56217 18.0476 8.19534 17.6571 8.58586L13.4214 12.8215C13.027 13.2159 12.3875 13.216 11.993 12.8215L9.87989 10.7084L7.75859 12.8297C7.36806 13.2202 6.7349 13.2202 6.34437 12.8297C5.95385 12.4391 5.95385 11.806 6.34437 11.4155L9.16571 8.59412C9.56013 8.19969 10.1996 8.19968 10.5941 8.59412L12.7072 10.7073L16.2428 7.17165C16.6334 6.78113 17.2665 6.78113 17.6571 7.17165Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation2Line);
export default __webpack_public_path__ + "static/media/presentation_2_line.d36ae12134d9140511e8ef76b3d12c3e.svg";
export { ForwardRef as ReactComponent };